(function () {
  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function getText(el) {
    if (!el) return "";
    return (el.textContent || "").replace(/\s+/g, " ").trim();
  }

  // Convert "4,66 €", "€4.66", "13,98", "13,98 EUR" -> cents
  function toCents(rawText) {
    if (!rawText) return null;
    const num = rawText
      .replace(/[^\d,.\-]/g, "") // keep digits , . -
      .replace(",", ".");
    const val = Number(num);
    if (!isFinite(val)) return null;
    return Math.round(val * 100);
  }

  // Force SAME style as diffuser: symbol + EUR
  function formatMoneyWithCurrency(cents) {
    if (cents == null) return "";
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      const fmt =
        Shopify.money_with_currency_format ||
        Shopify.money_format ||
        "{{amount_with_currency}}";
      return Shopify.formatMoney(cents, fmt);
    }
    // fallback
    return (cents / 100).toFixed(2) + " EUR";
  }

  function setThemePrice(root, mainText, compareText) {
    const priceBlock = qs(root, '[id^="price-"]');
    if (!priceBlock) return;

    const priceRoot = qs(priceBlock, ".price");
    if (!priceRoot) return;

    const regularEl = qs(priceRoot, ".price__regular .price-item--regular");
    const saleEl = qs(priceRoot, ".price__sale .price-item--sale");
    const compareEl = qs(priceRoot, ".price__sale .price-item--regular");

    const onSale = !!compareText;
    priceRoot.classList.toggle("price--on-sale", onSale);

    const mainCents = toCents(mainText);
    const compareCents = toCents(compareText);

    if (!onSale) {
      if (regularEl) regularEl.innerHTML = formatMoneyWithCurrency(mainCents);
    } else {
      if (saleEl) saleEl.innerHTML = formatMoneyWithCurrency(mainCents);
      if (compareEl) compareEl.innerHTML = formatMoneyWithCurrency(compareCents);
    }
  }

  function setTotal(root, totalText, show) {
    const priceBlock = qs(root, '[id^="price-"]');
    if (!priceBlock) return;

    const line = qs(priceBlock, ".dremis-total-today");
    const moneyEl = qs(priceBlock, ".dremis-total-money");
    if (!line || !moneyEl) return;

    if (!show) {
      line.hidden = true;
      return;
    }

    const totalCents = toCents(totalText);
    moneyEl.innerHTML = formatMoneyWithCurrency(totalCents);
    line.hidden = false;
  }

  function updatePrice(root) {
    const sealContainer = qs(root, ".sealsubs-container");
    if (!sealContainer) {
      setTotal(root, "", false);
      return false;
    }

    const activeOption = qs(root, ".sealsubs-container .sls-option-container.sls-active");
    if (!activeOption) {
      setTotal(root, "", false);
      return false;
    }

    const isOneTimeRow = !!qs(activeOption, "[data-one-time-option-radio]");

    if (isOneTimeRow) {
      const oneTimeMoney = qs(root, ".sealsubs-container .sls-one-time-price .money");
      const oneTime = getText(oneTimeMoney);
      if (!oneTime) return false;
      setThemePrice(root, oneTime, null);
      setTotal(root, "", false);
      return true;
    }

    const totalMoney = qs(activeOption, ".sls-selling-plan-group-price .money");
    const perDeliveryMoney = qs(activeOption, ".sls-selling-plan-group-price-per-delivery .money");

    const total = getText(totalMoney);
    const perDelivery = getText(perDeliveryMoney);

    const main = perDelivery || total;
    if (!main) return false;

    // Compare price = one-time price (per delivery compare)
    const oneTimeRowMoney = qs(root, ".sealsubs-container .sls-one-time-price .money");
    const oneTime = getText(oneTimeRowMoney);

    const mainVal = toCents(main);
    const oneTimeVal = toCents(oneTime);

    const showCompare =
      mainVal != null && oneTimeVal != null && oneTimeVal > mainVal;

    setThemePrice(root, main, showCompare ? oneTime : null);

    // Show Total line only when both values exist and differ
    if (perDelivery && total && toCents(total) !== toCents(perDelivery)) {
      setTotal(root, total, true);
    } else {
      setTotal(root, "", false);
    }

    return true;
  }

  function setSettling(root, isSettling) {
    const priceBlock = qs(root, '[id^="price-"]');
    if (!priceBlock) return;
    priceBlock.classList.toggle("dremis-price-settling", isSettling);
  }

  // Wraps updatePrice so the visible price stays hidden until we have a
  // VALID Seal-derived value (not just "nothing changed for a while" —
  // a quiet period with no valid data would otherwise reveal a stale or
  // default price too early). The price starts hidden already in the
  // server-rendered HTML (class baked into the Liquid markup) and via the
  // CSS rule in theme.liquid's <head> styles, so there is no flash of the
  // wrong value on first paint.
  //
  // The same hide-until-settled behavior is re-armed on every plan switch
  // (see bind()'s click/change handlers calling rearm()), because Seal
  // briefly re-renders the active option's markup when switching plans —
  // during that window the per-delivery price element can be momentarily
  // missing, causing a fallback to the full total price. Hiding during
  // that window prevents the user from seeing that wrong intermediate
  // value.
  function makeSettledUpdater(root) {
    const SETTLE_DELAY = 450;
    const MAX_WAIT = 4000;
    let settleTimer = null;
    let maxWaitTimer = null;
    let revealed = false;

    function startMaxWait() {
      clearTimeout(maxWaitTimer);
      maxWaitTimer = setTimeout(function () {
        if (!revealed) {
          setSettling(root, false);
          revealed = true;
        }
      }, MAX_WAIT);
    }

    // Make sure it's hidden even if the Liquid markup wasn't updated yet.
    setSettling(root, true);
    startMaxWait();

    function settledUpdate() {
      const isValid = updatePrice(root);

      if (!isValid) {
        // No usable Seal data yet — keep hiding, don't start/refresh the
        // settle timer on garbage data.
        return;
      }

      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        if (!revealed) {
          setSettling(root, false);
          revealed = true;
          clearTimeout(maxWaitTimer);
        }
      }, SETTLE_DELAY);
    }

    // Call this whenever the user switches purchase option. Re-hides the
    // price and resets the settle state so the brief "wrong" intermediate
    // value Seal renders mid-switch never becomes visible.
    function rearm() {
      revealed = false;
      if (settleTimer) clearTimeout(settleTimer);
      setSettling(root, true);
      startMaxWait();
    }

    return { settledUpdate: settledUpdate, rearm: rearm };
  }

  function bind(root) {
    const settler = makeSettledUpdater(root);

    let pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        settler.settledUpdate();
      });
    }

    schedule();
    setTimeout(schedule, 150);
    setTimeout(schedule, 500);
    setTimeout(schedule, 1200);
    setTimeout(schedule, 2500);
    setTimeout(schedule, 4000);
    setTimeout(schedule, 6000);

    root.addEventListener("click", function (e) {
      if (e.target && e.target.closest && e.target.closest(".sealsubs-container")) {
        settler.rearm();
        schedule();
        setTimeout(schedule, 200);
        setTimeout(schedule, 500);
        setTimeout(schedule, 900);
        setTimeout(schedule, 1500);
        setTimeout(schedule, 2500);
      }
    });

    root.addEventListener("change", function (e) {
      if (!e.target) return;
      if (
        (e.target.closest && e.target.closest(".sealsubs-container")) ||
        (e.target.closest && e.target.closest("variant-selects")) ||
        (e.target.closest && e.target.closest("product-variant-picker"))
      ) {
        settler.rearm();
        schedule();
        setTimeout(schedule, 200);
        setTimeout(schedule, 500);
        setTimeout(schedule, 900);
        setTimeout(schedule, 1500);
        setTimeout(schedule, 2500);
      }
    });

    // --- Robust observer setup ---
    // Seal Subscriptions can fully REPLACE the .sealsubs-container node
    // (not just mutate its children) when it finishes its own late init.
    // A MutationObserver attached directly to that node goes silently dead
    // once the node is detached/replaced. To survive that, we observe the
    // closest stable ancestor (the product form) for childList changes,
    // and re-attach the inner observer whenever the seal container
    // reference changes.

    let currentSealNode = null;
    let innerObserver = null;

    function attachInnerObserver(sealNode) {
      if (innerObserver) {
        innerObserver.disconnect();
        innerObserver = null;
      }
      if (!sealNode) return;

      innerObserver = new MutationObserver(function () {
        schedule();
      });

      innerObserver.observe(sealNode, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["class", "aria-checked", "value"]
      });

      currentSealNode = sealNode;
    }

    function findStableAncestor() {
      // Prefer the product form (stable across Seal re-renders),
      // fall back to root itself.
      return (
        (root.querySelector && root.querySelector('form[action*="/cart/add"]')) ||
        root
      );
    }

    function ensureObserverFresh() {
      const sealNode = qs(root, ".sealsubs-container");
      if (sealNode && sealNode !== currentSealNode) {
        attachInnerObserver(sealNode);
        schedule();
      } else if (!sealNode && currentSealNode) {
        // container disappeared (about to be replaced) — wait for next check
        currentSealNode = null;
        if (innerObserver) {
          innerObserver.disconnect();
          innerObserver = null;
        }
      }
    }

    let tries = 0;
    const poll = setInterval(function () {
      tries += 1;
      ensureObserverFresh();
      if (currentSealNode && tries >= 5) {
        // Once we have a node, slow down polling but keep checking for
        // node replacement (covers Seal's late full re-render).
        clearInterval(poll);
        setInterval(ensureObserverFresh, 800);
      } else if (tries >= 40) {
        clearInterval(poll);
      }
    }, 200);

    // Outer observer: watches the stable ancestor for childList changes so
    // we notice immediately if Seal swaps the whole container node out,
    // rather than waiting for the next poll tick.
    const stableAncestor = findStableAncestor();
    if (stableAncestor) {
      const outerObserver = new MutationObserver(function () {
        ensureObserverFresh();
      });
      outerObserver.observe(stableAncestor, {
        childList: true,
        subtree: true
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    const productInfo = document.querySelector("product-info");
    bind(productInfo || document);
  });
})();